import FavoriteIcon from "@mui/icons-material/Favorite";
import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import { COLOR_LIGHT_BLUE } from "shared/theme/colors";
import { FavoriteCard } from "./styled";

const FavoriteGames: FC = () => {
  return (
    <SpaceBetweenCenter gap={2}>
      {[...Array(5)].map((_, index) => (
        <FavoriteCard key={`favorite-games-card-${index}`}>
          <FavoriteIcon sx={{ fontSize: "54px", color: COLOR_LIGHT_BLUE }} />
        </FavoriteCard>
      ))}
    </SpaceBetweenCenter>
  );
};

export default FavoriteGames;
